import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  cardContainer: {
    margin: '20px 0',
    display: 'grid',
    gridGap: theme.spacing(1.25),
    gridTemplateColumns: 'repeat(auto-fit, minmax(186px, 1fr))',
    '@media(max-width: 430px)': {
      display: 'grid',
      gridGap: theme.spacing(1.25),
      gridTemplateColumns: 'minmax(40px, 1fr)'
    }
  },
  actionsRoot: {
    display: 'flex',
    flex: '1 1 auto',
    marginBottom: theme.spacing(2),
    cursor: 'pointer'
  },
  icon: {
    fontSize: 70,
    margin: theme.spacing(2)
  },
  box: {
    textAlign: 'left',
    margin: theme.spacing(2)
  },
  chevron: {
    margin: theme.spacing('auto', 2, 'auto', 'auto')
  },
  benefitAd: {
    maxHeight: '300px'
  },
  logo: {
    marginTop: '12px',
    marginRight: '12px'
  }
}));